import { render, staticRenderFns } from "./areaAllocation.vue?vue&type=template&id=44dc93ab&scoped=true&"
import script from "./areaAllocation.vue?vue&type=script&lang=js&"
export * from "./areaAllocation.vue?vue&type=script&lang=js&"
import style0 from "./areaAllocation.vue?vue&type=style&index=0&id=44dc93ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dc93ab",
  null
  
)

export default component.exports